import React from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';

import EventForm from './EventForm';

const styles = theme => ({
  content: {
    // padding: theme.spacing(3),
    height: 'calc(100vh - 64px)',
    backgroundColor: '#424242',
    width: '100%',
  },
});

const EventMain = props => {
  const { classes } = props;

  return (
    <React.Fragment>
      <div className={clsx(classes.content)}>
        <EventForm />
      </div>
    </React.Fragment>
  );
};

export default connect()(
  withStyles(styles)(EventMain),
);
